import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { DataTable } from "@/components/admin/DataTable";

const COLS = [["created_at", "Date"], ["status", "Status"], ["category_name", "Category"], ["payment_label", "Package"], ["organisation", "Organisation"],
  ["name", "Name"], ["email", "Email"], ["country", "Country"], ["services", "Services"], ["opportunities", "Looking for"]];

export const AdminAgap = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/agap").then((r) => setD(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  const exportCsv = async () => {
    let r;
    try { r = await api.get("/admin/agap/export", { responseType: "blob" }); } catch (e) { return toast.error(formatApiError(e)); }
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data); a.download = "agap-partners.csv"; a.click();
  };
  const rows = d?.registrations.map((r) => ({ ...r, services: r.services.join(", "), opportunities: r.opportunities.join(", ") }));
  return (
    <div data-testid="admin-agap">
      {d && (
        <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
          <div className="flex gap-8 text-sm">
            <p data-testid="admin-agap-total"><span className="font-display text-3xl font-bold block">{d.registrations.length}</span>partners</p>
            <p data-testid="admin-agap-free"><span className="font-display text-3xl font-bold block">{d.free}</span>free sign-ups</p>
            <p data-testid="admin-agap-paid"><span className="font-display text-3xl font-bold block">£{d.revenue.toLocaleString()}</span>paid online ({d.paid})</p>
          </div>
          <button onClick={exportCsv} data-testid="admin-agap-export" className="inline-flex items-center gap-2 border border-[#0A0A0A] px-4 py-2 text-sm hover:bg-[#0A0A0A] hover:text-white transition-colors"><Download size={14} /> Export CSV</button>
        </div>
      )}
      <DataTable rows={rows || null} cols={COLS} testid="admin-agap-table" />
    </div>
  );
};
